import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'text-copy',
  templateUrl: './text-copy.component.html',
  styleUrls: ['./text-copy.component.scss']
})
export class TextCopyComponent implements OnInit {
  @Input() value: string;
  @ViewChild('input', { static: true }) input: ElementRef;

  copied = false;

  constructor() { }

  ngOnInit() {
  }

  onCopy(): boolean {
    this.input.nativeElement.select();
    document.execCommand('copy');

    this.copied = true;
    window.setTimeout(() => {
      this.copied = false;
      this.input.nativeElement.setSelectionRange(0, 0);
    }, 3000);
    return false;
  }
}
